module.exports = __webpack_public_path__ + "img/u49.4c8e2453.png";